<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center class="text-xs-center">
      <v-flex v-if="project" xs12 md4 class="text-xs-right">
        <!-- Title -->
        <v-layout justify-center class="margin-bottom">
          <v-flex shrink>
            <v-icon :color="project.color" small>fas fa-square-full</v-icon>
          </v-flex>
          <v-flex
            shrink
            class="font-weight-black title mx-2"
            :to="{ name: 'home' }"
          >
            <router-link :to="{ name: 'projectView', params: { projectId } }">
              {{ project.data.name }}
            </router-link>
          </v-flex>
        </v-layout>

        <v-layout column>
          <v-flex>
            <v-textarea
              solo
              label="Notes"
              rows="15"
              v-model="note"
            ></v-textarea>
          </v-flex>
          <v-flex>
            <v-btn class="elevation-2" color="primary" @click="onSave">
              Save
            </v-btn></v-flex
          >
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { Time } from "@/lib/Time";
import { Record } from "@/classes/Record/Record";
export default {
  computed: {
    ...mapState(["recordReader", "projectReader"]),
    projectId() {
      return this.$route.params.projectId;
    },
    project() {
      if (this.projectReader.ready) {
        return this.projectReader.getByProjectId(this.$route.params.projectId);
      }
      return undefined;
    }
  },
  data() {
    return {
      note: ""
    };
  },
  methods: {
    onSave() {
      let record = this.recordReader.create(this.$route.params.projectId);
      record.updateData({
        type: Record.type.checkIn,
        startTimestamp: Time.date.getNow(),
        endTimestamp: Time.date.getNow(),
        UTCOffset: Time.date.getUTCOffSet(),
        value: 1,
        note: this.note
      });
      record.save();
      this.$router.push({
        name: "projectView",
        params: { projectId: this.$route.params.projectId }
      });
    }
  }
};
</script>
<style scoped>
.margin-bottom {
  margin-bottom: 50px;
}
</style>
